export interface KeywordDownloadGq {
  id: number;
  projectId: number;
  fileName: string;
  downloadUrl?: string;

  createTime: string;
  processStartTime?: string;
  processEndTime?: string;
  expirationTime?: string;
  processAttempts: number;

  keywordCountTotal: number;
  keywordCountProgress: number;
  state: KeywordDownloadStateGq;
}

export enum KeywordDownloadStateGq {
  QUEUED = 'QUEUED',
  TIMED_OUT = 'TIMED_OUT',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export const KeywordDownloadGqProps = `
    id
    projectId
    fileName
    downloadUrl

    createTime
    processStartTime
    processEndTime
    expirationTime
    processAttempts

    keywordCountTotal
    keywordCountProgress
    state
`;
